import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	mobileNo: string
	newPassword: string
}

interface ResponseDataShape {
	success: boolean
	data: { otpValidTill: number }
}

export async function userPasswordResetApi(payload: RequestDataShape) {
	const endpoint = "/user/password/reset/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest(payload)
	return response.data
}
